import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Type } from '@spotify-internal/encore-creator-web';
import styled from 'styled-components';
import tokens from '@spotify-internal/encore-foundation';
import { CONFLICT, LOADING, ERROR, IDLE, SUBMIT_SUCCESS } from '../../../../store/selectors.ts';
import { AnimatedAlert } from 'components/Shared/AnimatedAlert';
import { trackEvent } from 'lib/Tracking';
import { PodcastModalBody } from '../../../Shared/PodcastModal/index.tsx';

const ItemContainer = styled.div`
  border-top: 1px solid #bdbdbd;
`;

const Item = styled.div`
  align-items: center;
  border-bottom: 1px solid #bdbdbd;
  padding: ${tokens.spacer16} 0;
  display: flex;

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: start;
  }
`;

const StyledIndicator = styled(Type.p)`
  margin-left: ${tokens.spacer8};
  margin-right: ${tokens.spacer32};
  width: 200px;

  @media (max-width: 480px) {
    margin: 0;
  }
`;

export class PodcastUpdateReview extends Component {
  /* eslint-disable react/no-unused-prop-types */
  static propTypes = {
    newFeedUrl: PropTypes.string,
    aggregator: PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string,
    }),
    status: PropTypes.oneOf([CONFLICT, LOADING, ERROR, IDLE, SUBMIT_SUCCESS]),
    shouldShowAggregators: PropTypes.bool.isRequired,
    errorMessage: PropTypes.node,
  };

  componentDidMount() {
    trackEvent({
      category: 'feed-update',
      action: 'review',
    });
  }

  renderItem = (field, value) => (
    <Item>
      <StyledIndicator variant={Type.body2} color="gray60" condensed>
        {field}
      </StyledIndicator>
      <Type as="p" condensed>
        {value}
      </Type>
    </Item>
  );

  render() {
    return (
      <Fragment>
        {/* istanbul ignore next */ this.props.status === ERROR && (
          <AnimatedAlert
            data-qa="error-alert"
            data-testid="error-alert"
            message={
              this.props.errorMessage
                ? this.props.errorMessage
                : 'Unable to update your podcast. Wait a few minutes, then try again.'
            }
          />
        )}
        <PodcastModalBody data-qa="review-and-submit">
          <Type as="h1" variant={Type.heading2}>
            Does everything look OK?
          </Type>

          <ItemContainer>
            {this.renderItem('Link to your RSS feed', this.props.newFeedUrl)}
            {this.props.shouldShowAggregators &&
              this.renderItem('Hosting Provider', this.props.aggregator.name)}
          </ItemContainer>
        </PodcastModalBody>
      </Fragment>
    );
  }
}
